import { API_URL } from '../../../app-config/constants';
import { ObjectiveSuggestions } from '../../../types/ObjectiveSuggestions';
import { get } from '../request';

getByFeedbackRequestId.operation = 'READ';
export function getByFeedbackRequestId(id: string): Promise<ObjectiveSuggestions> {
    return get(`${API_URL}/unified-feedback/objective-suggestions/${id}`);
}
